export default {
  CONFIGURATION_RECEIVED: "CONFIGURATION_RECEIVED",
};



// WEBPACK FOOTER //
// ./src/redux/types/config.js